import React, { useState, useMemo, useCallback } from "react";
import { EstiloButton } from "./App";
import styled from "styled-components";
import logoCata from "./assets/logo_cata.png";
import {
  FormGroup,
  ContenedorFormBase,
  ResultadoLine,
} from "./CostCalculadora";
import { useData } from "./DataContext";
import { Alert, CloseButton } from "./App";

const ContenedorDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem;
  margin-top: 2rem;
  margin-bottom: 4rem;
`;

const ResultadoCosto = styled.div`
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  margin: 0.7rem 1rem;
  border-radius: 8px;
  width: 100%;
  max-width: 400px;
  padding: 1.5rem;
  background-image: url(${logoCata});
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: top;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  h5 {
    margin-top: 2.5rem;
  }
  color: black;
`;

const TarifaPorCosto = () => {
  const {
    costoUnidadesData,
    sueldoData,
    viaticosNacionalesData,
    viaticosInternacionalesData,
    viaticoData,
  } = useData();

  const sueldoPorHora = useMemo(
    () => (sueldoData[0]?.sueldo * 1.6 * 1.083) / 26 / 8,
    [sueldoData]
  );
  const sueldoPorDia = useMemo(
    () => (sueldoData[0]?.sueldo * 1.6 * 1.083) / 26,
    [sueldoData]
  );
  const viaticoProvincial = viaticoData[0]?.viatico;

  const viaticoNacional = useMemo(() => {
    const { almuerzo, cama, cena, desayuno, merienda } =
      viaticosNacionalesData[0] || {};
    return almuerzo + cama + cena + desayuno + merienda;
  }, [viaticosNacionalesData]);

  const viaticoInternacional = useMemo(() => {
    const { almuerzo, cama, cena, desayuno, merienda } =
      viaticosInternacionalesData[0] || {};
    return almuerzo + cama + cena + desayuno + merienda;
  }, [viaticosInternacionalesData]);

  const { costoBus40, costoBusDoble, costoVan19, costoMiniBus } =
    costoUnidadesData[0] || {};

  const [unidad, setUnidad] = useState("");
  const [cantidadUnidades, setCantidadUnidades] = useState(1);
  const [viatico, setViatico] = useState("");
  const [kilometros, setKilometros] = useState("");
  const [kilometrosVacios, setKilometrosVacios] = useState(0);
  const [tiempoEspera, setTiempoEspera] = useState(0);
  const [diasEstadia, setDiasEstadia] = useState(0);
  const [pasajeros, setPasajeros] = useState("");
  const [porcentaje, setPorcentaje] = useState(35); // Este estado ahora se utiliza correctamente
  const [tarifaTraslado, setTarifaTraslado] = useState(0);
  const [calculated, setCalculated] = useState(false); // Se añadió calculated en el estado
  const [showAlert, setShowAlert] = useState(false);

  const closeAlert = () => setShowAlert(false);

  // Función para cambiar el porcentaje
  const handlePorcentajeChange = (e) => {
    const selectedPorcentaje = parseInt(e.target.value);
    setPorcentaje(selectedPorcentaje); // Ahora se usa setPorcentaje correctamente
  };

  const calcularTraslado = useCallback(() => {
    if (kilometros < 1 || pasajeros < 1 || !unidad) {
      setShowAlert(true);
      return;
    }
    let unidades = parseInt(cantidadUnidades);
    let totalKm =
      parseInt(kilometros < 60 ? 60 : kilometros) + parseInt(kilometrosVacios);
    const cantidadChoferes = parseInt(kilometros < 200 ? 1 : 2);
    const espera = parseInt(tiempoEspera * sueldoPorHora);
    const estadia = parseInt(diasEstadia * sueldoPorDia);

    let tarifaViatico = 0;
    if (viatico === "provincial") tarifaViatico = viaticoProvincial;
    if (viatico === "nacional") tarifaViatico = viaticoNacional;
    if (viatico === "internacional") tarifaViatico = viaticoInternacional;
    tarifaViatico *= cantidadChoferes;

    let tarifaUnidad = 0;
    switch (unidad) {
      case "bus40":
        tarifaUnidad = costoBus40;
        break;
      case "busDoble":
        tarifaUnidad = costoBusDoble;
        break;
      case "van19":
        tarifaUnidad = costoVan19;
        break;
      default:
        tarifaUnidad = costoMiniBus;
    }

    const tarifaKm = totalKm * tarifaUnidad;

    let tarifaTotal = (tarifaKm + tarifaViatico + espera + estadia) * unidades;

    if (viatico === "internacional") tarifaTotal = tarifaTotal * 1.7;

    setTarifaTraslado(tarifaTotal);
    setCalculated(true);
  }, [
    unidad,
    viatico,
    kilometros,
    kilometrosVacios,
    tiempoEspera,
    diasEstadia,
    costoBus40,
    costoBusDoble,
    costoVan19,
    costoMiniBus,
    viaticoProvincial,
    viaticoNacional,
    viaticoInternacional,
    sueldoPorHora,
    sueldoPorDia,
    cantidadUnidades,
    pasajeros, // Añadir pasajeros como dependencia
  ]);

  const totalConPorcentaje = tarifaTraslado * (1 + porcentaje / 100);
  const porPasajero = totalConPorcentaje / pasajeros;

  return (
    <ContenedorDiv>
      {showAlert && (
        <Alert>
          <CloseButton onClick={closeAlert}>&times;</CloseButton>
          Por favor, complete:{" "}
          {!unidad
            ? "Unidad"
            : kilometros < 1
            ? "km recorridos"
            : "Cantidad de Pasajeros"}
        </Alert>
      )}
      <ContenedorFormBase>
        <h4>Tarifa según costo</h4>
        <form>
          <FormGroup>
            <label>Unidad:</label>
            <select
              id="unidad"
              name="unidad"
              value={unidad}
              onChange={(e) => setUnidad(e.target.value)}
            >
              <option value="">seleccione</option>
              <option value="bus40">Bus40</option>
              <option value="busDoble">BusDoble</option>
              <option value="van19">Van19</option>
              <option value="minibus">Minibus24</option>
            </select>
          </FormGroup>
          <FormGroup>
            <label>Cantidad Unidades:</label>
            <input
              type="number"
              value={cantidadUnidades}
              onChange={(e) => setCantidadUnidades(e.target.value)}
              required
            />
          </FormGroup>
          <FormGroup>
            <label>Km recorridos, (x unidad):</label>
            <input
              type="number"
              value={kilometros}
              onChange={(e) => setKilometros(e.target.value)}
              required
            />
          </FormGroup>
          <FormGroup>
            <label>Km vacíos, (x unidad):</label>
            <input
              type="number"
              value={kilometrosVacios}
              onChange={(e) => setKilometrosVacios(e.target.value)}
              required
            />
          </FormGroup>
          <FormGroup>
            <label>Días Estadía:</label>
            <input
              type="number"
              value={diasEstadia}
              onChange={(e) => setDiasEstadia(e.target.value)}
              required
            />
          </FormGroup>
          <FormGroup>
            <label>Tiempo de espera (horas):</label>
            <input
              type="number"
              value={tiempoEspera}
              onChange={(e) => setTiempoEspera(e.target.value)}
              required
            />
          </FormGroup>
          <FormGroup>
            <label>Viatico:</label>
            <select
              id="viatico"
              name="viatico"
              value={viatico}
              onChange={(e) => setViatico(e.target.value)}
            >
              <option value="">no corresponde</option>
              <option value="provincial">Provincial</option>
              <option value="nacional">Nacional</option>
              <option value="internacional">Internacional</option>
            </select>
          </FormGroup>
          <FormGroup>
            <label>Cantidad de Pasajeros:</label>
            <input
              type="number"
              value={pasajeros}
              onChange={(e) => setPasajeros(e.target.value)}
            />
          </FormGroup>
          <EstiloButton type="button" onClick={calcularTraslado}>
            Calcular
          </EstiloButton>
        </form>
      </ContenedorFormBase>
      {calculated && (
        <ResultadoCosto>
          <h5>Tarifa:</h5>
          <div>
            <strong>Pasajeros: {pasajeros}</strong>
            <ResultadoLine></ResultadoLine>
            <div>
              <strong>
                Total Costo:{" "}
                {tarifaTraslado.toLocaleString("es-AR", {
                  style: "currency",
                  currency: "ARS",
                })}
              </strong>
              <FormGroup>
                <label>Margen:</label>
                <select value={porcentaje} onChange={handlePorcentajeChange}>
                  <option value={35}>35% deseable</option>
                  <option value={30}>30%</option>
                  <option value={25}>25%</option>
                  <option value={20}>20%</option>
                </select>
              </FormGroup>
              <strong>
                Total con {porcentaje}%:{" "}
                {totalConPorcentaje.toLocaleString("es-AR", {
                  style: "currency",
                  currency: "ARS",
                })}
              </strong>
            </div>
            <div>
              {pasajeros < 2 ? (
                ""
              ) : (
                <strong>
                  Por pasajero:{" "}
                  {porPasajero.toLocaleString("es-AR", {
                    style: "currency",
                    currency: "ARS",
                  })}
                </strong>
              )}
            </div>
          </div>
        </ResultadoCosto>
      )}
    </ContenedorDiv>
  );
};

export default TarifaPorCosto;
